import Address from './Address';
import OrderItem from './OrderItem';
import OrderField from './OrderField';
import {Fields, Model} from '@vuex-orm/core';

export default class OrderV2 extends Model {
    public static modelName = 'OrderV2';
    public static entity = 'orders/v2';

    public id!: number;
    public token?: string;
    public amountCents!: number;
    public amountDiscountCents!: number;
    public amountTaxCents!: number;
    public amountDueCents!: number;
    public amountPaidCents!: number;
    public cashRoundedCents!: number;
    public amountShippingCents!: number;
    public amountTipCents!: number;
    public orderNumber?: string;
    public dateIssued?: string;
    public datePaid?: string;
    public currency?: number;
    public type?: number;
    public status?: string;
    public paymentTerms?: number;
    public poNumber?: string;
    public convenienceFeeEnabled?: boolean;
    public createdPlatform?: number;
    public paymentMethod?: string;
    public comments?: string;
    public shippingMethod?: string;
    public subscriptionId!: number;
    public customerId!: number;
    public billingAddress?: Address;
    public shippingAddress?: Address;
    public items?: OrderItem[];
    public orderFields?: OrderField[];

    public static fields(): Fields {
        return {
            id: this.number(0),
            token: this.string(''),
            amountCents: this.number(0),
            amountDiscountCents: this.number(0),
            amountTaxCents: this.number(0),
            amountDueCents: this.number(0),
            amountPaidCents: this.number(0),
            cashRoundedCents: this.number(0),
            amountShippingCents: this.number(0),
            amountTipCents: this.number(0),
            orderNumber: this.string(''),
            dateIssued: this.string('0000-00-00 00:00:00'),
            datePaid: this.string('0000-00-00 00:00:00'),
            currency: this.number(0),
            type: this.number(0),
            status: this.string(''),
            paymentTerms: this.number(0),
            poNumber: this.string(''),
            convenienceFeeEnabled: this.boolean(false),
            createdPlatform: this.number(0),
            paymentMethod: this.string(''),
            comments: this.string(''),
            shippingMethod: this.string(''),
            subscriptionId: this.number(0),
            customerId: this.number(0),
            shippingAddress: this.hasOne(Address, 'id', 'shippingAddressId'),
            billingAddress: this.hasOne(Address, 'id', 'billingAddressId'),
            items: this.hasMany(OrderItem, 'orderId'),
            orderFields: this.hasMany(OrderField, 'orderId'),
        };
    }
}
